/**
 * Contexto de Autenticação Genérico
 * Este contexto é independente de provedor e nunca deve importar de keycloak-js ou @azure/msal-browser
 */
import { createContext } from 'react';
import { AuthContextState } from './types';

/**
 * O contexto de autenticação
 * Componentes consomem isso via hook useAuth()
 */
export const AuthContext = createContext<AuthContextState | undefined>(undefined);
